import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.loading;
export const loadingCountSelector = (state: RootState) => getState(state).count;
